/* eslint-disable react-hooks/rules-of-hooks */
"use client"

import type React from "react"

import {
  Button,
  Input,
  HStack,
  VStack,
  Box,
  Text,
  IconButton,
} from "@chakra-ui/react"
import { useForm } from "react-hook-form"
import { ModalAlert } from "@/components/ModalStyled/Modal"
import { useNavigate, useParams } from "react-router-dom"
import { useState } from "react"
import ModalRetorno from "@/components/components/ModalRetorno"
import { BoxTitle } from "@/components/BoxTitle" // Importação do BoxTitle mantida e usada!

interface ObsCargaFormData {
  dt: number | null
  doca: number | null
  previsaoEntradaData: string | null
  previsaoEntradaHora: string | null
  previsaoSaidaData: string | null
  previsaoSaidaHora: string | null
}

const ObsCarga: React.FC = () => {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const isEdit = Boolean(id)

  const [isRetornoOpen, setIsRetornoOpen] = useState(false)
  const [mensagemRetorno, setMensagemRetorno] = useState("")
  const [tipoRetorno, setTipoRetorno] = useState<"sucesso" | "erro">("sucesso")

  const { handleSubmit, setValue, watch, reset } = useForm<ObsCargaFormData>({
    defaultValues: {
      dt: 10541588, // Valor inicial conforme a imagem
      doca: 5,     // Valor inicial conforme a imagem
      previsaoEntradaData: "2025-05-25",
      previsaoEntradaHora: "10:25:36",
      previsaoSaidaData: "2025-05-25",
      previsaoSaidaHora: "14:25:36",
    },
  })

  const safeNumberConversion = (value: any): number | null => {
    if (value === undefined || value === null || value === "") {
      return null
    }

    const numValue = Number(value)
    if (isNaN(numValue)) {
      return null
    }

    return numValue
  }

  const onSubmit = async (formData: ObsCargaFormData) => {
    try {
      setMensagemRetorno("Observação de Carga salva com sucesso!")
      setTipoRetorno("sucesso")
      setIsRetornoOpen(true)
    } catch (error) {
      setMensagemRetorno("Erro ao salvar Observação de Carga. " + ((error as any)?.message || ""))
      setTipoRetorno("erro")
      setIsRetornoOpen(true)
    }
  }

  const getModalTitle = () => {
    return "Observação de Carga"
  }

  const renderHeader = () => (
    <HStack w={"100%"} justify="space-start" align="center" >
      <Text fontSize="xl" fontWeight="bold">
        {getModalTitle()}
      </Text>
    </HStack>
  )

  const renderBody = () => {
    return (
      <Box p={4} as="form" onSubmit={handleSubmit(onSubmit)}>
        <VStack spacing={6} align="center">
          <HStack spacing={6} justifyContent="center" width="100%">
            <Box width="45%"> {/* Largura para DT */}
              <BoxTitle title="DT">
                <Input
                  placeholder='10541588'
                  size='md'
                  value={watch("dt") || ''}
                  onChange={(e) => setValue("dt", safeNumberConversion(e.target.value))}
                  textAlign="center"
                  borderRadius="full"
                  borderColor="#ccc"
                  _focus={{ borderColor: "#117BAA" }}
                />
              </BoxTitle>
            </Box>

            <Box width="45%">
              <BoxTitle title="Doca">
                <Input
                  placeholder='5'
                  size='md'
                  value={watch("doca") || ''}
                  onChange={(e) => setValue("doca", safeNumberConversion(e.target.value))}
                  textAlign="center"
                  borderRadius="full"
                  borderColor="#ccc"
                  _focus={{ borderColor: "#117BAA" }}
                />
              </BoxTitle>
            </Box>
          </HStack>

          {/* Linha Previsão Entrada */}
          <HStack spacing={6} justifyContent="center" width="100%">
            <Box width="45%"> {/* Largura para Previsão Entrada Data */}
              <BoxTitle title="Previsão Entrada">
                <Input
                  size='md'
                  type='date'
                  value={watch("previsaoEntradaData") || ''}
                  onChange={(e) => setValue("previsaoEntradaData", e.target.value)}
                  borderRadius="full"
                  borderColor="#ccc"
                  _focus={{ borderColor: "#117BAA" }}
                />
              </BoxTitle>
            </Box>

            <Box width="45%"> {/* Largura para Previsão Entrada Hora */}
              <BoxTitle title="Hora">
                <Input
                  size='md'
                  type='time'
                  value={watch("previsaoEntradaHora") || ''}
                  onChange={(e) => setValue("previsaoEntradaHora", e.target.value)}
                  borderRadius="full"
                  borderColor="#ccc"
                  _focus={{ borderColor: "#117BAA" }}
                />
              </BoxTitle>
            </Box>
          </HStack>

          {/* Linha Previsão Saída */}
          <HStack spacing={6} justifyContent="center" width="100%">
            <Box width="45%"> {/* Largura para Previsão Saída Data */}
              <BoxTitle title="Previsão Saída">
                <Input
                  size='md'
                  type='date'
                  value={watch("previsaoSaidaData") || ''}
                  onChange={(e) => setValue("previsaoSaidaData", e.target.value)}
                  borderRadius="full"
                  borderColor="#ccc"
                  _focus={{ borderColor: "#117BAA" }}
                />
              </BoxTitle>
            </Box>

            <Box width="45%"> {/* Largura para Previsão Saída Hora */}
              <BoxTitle title="Hora">
                <Input
                  size='md'
                  type='time'
                  value={watch("previsaoSaidaHora") || ''}
                  onChange={(e) => setValue("previsaoSaidaHora", e.target.value)}
                  borderRadius="full"
                  borderColor="#ccc"
                  _focus={{ borderColor: "#117BAA" }}
                />
              </BoxTitle>
            </Box>
          </HStack>
        </VStack>
      </Box>
    )
  }

  const renderFooter = () => {
    return (
      <HStack spacing={4}>
        <Button backgroundColor={"#117baa"} onClick={handleSubmit(onSubmit)} color={"white"}>
          Salvar
        </Button>
        <Button
          backgroundColor={"gray.300"}
          onClick={() => navigate(-1)}
          color={"gray.800"}
        >
          Cancelar
        </Button>
      </HStack>
    )
  }

  return (
    <>
      <ModalAlert
        isOpen={true}
        xIsback
        size={'md'}
        title={renderHeader()}
        body={renderBody()}
        footer={renderFooter()}
      />

      <ModalRetorno
        isOpen={isRetornoOpen}
        onClose={() => {
          setIsRetornoOpen(false)
          if (tipoRetorno === "sucesso") {
            navigate(-1)
          }
        }}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  )
}

export default ObsCarga